export default __webpack_public_path__ + "static/media/information--height-limit--g1.55576056.png";